import { cn } from "@/lib/utils";
import type { PartnerTier } from "@/schemas/partner-directory";

// Figma tag colours: Base grey-200/grey-700, Silver grey-100/grey-600,
// Gold orange-50/orange-800. The 6px radius is not a design-system token.
const TIER_STYLES: Record<PartnerTier, string> = {
  base: "bg-grey-200 text-grey-700",
  silver: "bg-grey-100 text-grey-600",
  gold: "bg-orange-50 text-orange-800",
};

interface PartnerTierBadgeProps {
  tier: PartnerTier;
  label: string;
  className?: string;
}

export function PartnerTierBadge({
  tier,
  label,
  className,
}: PartnerTierBadgeProps) {
  return (
    <span
      data-tier={tier}
      className={cn(
        "text-ds-body-xs inline-flex w-fit items-center rounded-[6px] px-[5px] py-1 leading-none font-medium whitespace-nowrap",
        TIER_STYLES[tier],
        className
      )}
    >
      {label}
    </span>
  );
}
